module.exports = __webpack_public_path__ + "muktijuddho-ad598abd8fb3b8858ef4.svg";